import { getFeatureSetting } from "../../feature-settings";
import { SerializedComponent } from "../../components/SerializedApp";
import {
    ComponentBuilder,
    ComponentConfiguratorContext,
    WireActionHydrator,
    WireInflationBackend,
} from "../components";
import { EnumPropertyHandler } from "../components/property-handlers";
import { PropertySection } from "../components/property-sections";
import {
    ActionDescription,
    ActionKind,
    InputOutputTables,
    MutatingScreenKind,
    PropertyDescription,
} from "../description";
import { ActionDescriptor } from "./action-descriptor";
import { BaseActionHandler } from "./base";
import { Sound } from "../../sound";

interface PlaySoundActionDescription extends ActionDescription {
    readonly sound: PropertyDescription;
}

const labelForSound: Record<Sound, string> = {
    [Sound.Alert]: "Alert",
    [Sound.Blip]: "Blip",
    [Sound.CalmThought]: "Calm Thought",
    [Sound.CloseEncounters]: "Close Encounters",
    [Sound.Hint]: "Hint",
    [Sound.NewThought]: "New Thought",
    [Sound.Ping]: "Ping",
    [Sound.Sonar]: "Sonar",
    [Sound.Pop]: "Pop",
};

const soundPropertyHandler = new EnumPropertyHandler(
    { sound: Sound.Alert },
    "Sound",
    "Sound",
    Object.values(Sound).map(s => ({ label: labelForSound[s], value: s })),
    PropertySection.Data,
    "dropdown"
);

export class PlaySoundHandler extends BaseActionHandler<PlaySoundActionDescription> {
    public readonly kind = ActionKind.PlaySound;
    // FIXME: proper icon
    public readonly iconName = "sound";

    public getDescriptor(
        _desc: PlaySoundActionDescription | undefined,
        _tables: InputOutputTables | undefined,
        _ccc: ComponentConfiguratorContext,
        _mutatingScreenKind: MutatingScreenKind | undefined
    ): ActionDescriptor {
        return {
            name: "Play Sound",
            needsScreenContext: false,
            isLegacy: !getFeatureSetting("playSound"),
            properties: [soundPropertyHandler],
        };
    }

    public makeAction(
        builder: ComponentBuilder,
        desc: PlaySoundActionDescription,
        _tables: InputOutputTables
    ): SerializedComponent | undefined {
        const { b } = builder;

        const sound = soundPropertyHandler.getEnum(desc);

        return b.playSound(b.constant(sound));
    }

    public inflate(_ib: WireInflationBackend, desc: PlaySoundActionDescription): WireActionHydrator | undefined {
        const sound = soundPropertyHandler.getEnum(desc);

        return () => {
            return async ab => {
                ab.actionCallbacks.playSound(sound);
                return true;
            };
        };
    }
}
